<template>
  <transition name="modal">
    <div class="results">
      <div id="submenu-container">

        <div class="center">
          <div class="goBack" @click="$eventBus.$emit('nav', 'prev')">
          <button class="color--current flex flex--centerY" style="overflow: visible;"><span class="icon arrowleft" style="width: 1.125rem; height: 2rem;"></span> Redigér dine svar</button>
        </div>
          <div id="submenu">
            <ul>
              <li class="active">
                <a href="#resultat">Resultat</a>
              </li>
              <li>
                <a href="#seksjon--1">Hva innebærer det?</a>
              </li>
              <li>
                <a href="#seksjon--2">Dine svar</a>
              </li>
              <li>
                <a href="#seksjon--3"
                  ><span v-if="category.category < 3">Gode drikkevaner</span
                  ><span v-else>Slik kan du drikke smartere</span></a
                >
              </li>
              <li v-if="category.category > 3">
                <a href="#seksjon--4">Slik kan du ta grep</a>
              </li>
              <li><a href="#seksjon--5">Avslutning</a></li>
              <li><a href="#seksjon--7">Lagre resultat</a></li>
              <li v-if="category.category > 2"><a href="#seksjon--6">Det finnes hjelp</a></li>
            </ul>
            <span id="slide-line"></span>
          </div>
        </div>
      </div>
      <div class="slide slide-results bg--dark pb--0">
        <div class="screen screen--0" id="resultat">
          <div class="screen__anchor"></div>
          <div class="screen__inner">
            <div class="grid-container grid-container--small pt--0 pl--0">
              <div class="grid-x">
                <div class="small-12 cell">
                  <div class="flex flex--centerY">
                    <span class="icon resultat-icon xl mr--0p5rem"></span>
                  </div>
                  <h1 class="mt--2rem" v-html="category.titleHtml">

                  </h1>

                  <p class="flex flex--center">
                    <a
                      class="scrolldown show-for-large"
                      href="#seksjon--1"
                      title="Se hva du kan gjøre"
                      >Se hva du kan gjøre
                      <span class="ml--0p5rem icon arrowdown dark"></span
                    ></a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <a
            class="scrolldown show-for-large"
            href="#seksjon--1"
            title="Se hva du kan gjøre"
            >Se hva du kan gjøre
            <span class="ml--0p5rem icon arrowdown dark"></span
          ></a>
        </div>

        <div class="screen screen--1" id="seksjon--1">
          <div class="screen__anchor"></div>
          <div class="screen__inner">
            <div class="grid-container grid-container--small pr--0 pl--0">
              <div class="grid-x">
                <div class="small-12 cell">
                  <h2>Hva innebærer det?</h2>

                  <div class="" :data-cat="category.category" v-if="(category.category > 1) && (getAlcoholPoints == 0)">
                    <p>
                      Du har oppgitt at du ikke drikker alkohol, men du har
                      samtidig svart at du har opplevd negative konsekvenser av
                      alkoholvanene dine.
                    </p>
                    <p>
                      Resultatet er både koplet til svarene om mengde og til
                      svarene om konsekvenser. Å ikke drikke i det hele tatt er
                      risikofritt. Men kanskje hadde du andre vaner før?
                    </p>
                  </div>
                  <div v-else-if="(category.category == 3) && (intervalCategory == 1)">
                    <p>
                      Du har oppgitt av du ikke drikker veldig mye alkohol, men du har samtidig svart at du har opplevd negative konsekvenser av alkoholvanene dine.
                    </p>
                    <p>
                      Resultatet er både koblet til svarene om mengde og til svarene om konsekvenser. Det innebærer at alkoholen risikerer å skade deg, og kan på sikt føre til negative konsekvenser i ditt liv – fysisk, psykisk eller sosialt.
                    </p>
                  </div>
                  <div v-else-if="(category.category == 4) && (intervalCategory == 1)">
                    <p>
                      Du har oppgitt at du ikke drikker veldig mye alkohol, men du har samtidig svart at du har opplevd negative konsekvenser av alkoholvanene dine.
                    </p>
                    <p>
                      Resultatet er både koblet til svarene om mengde og til svarene om konsekvenser. Svarene dine plasserer deg i kategorien ‘Skadelig bruk’. Det innebærer at drikkingen din påvirker livet ditt negativt – psykisk eller sosialt – og kan gi alvorlige fysiske konsekvenser.
                    </p>
                  </div>
                   <div v-else-if="(category.category == 5) && (intervalCategory == 1)">
                    <p>
                      Du har oppgitt at du ikke drikker veldig mye alkohol, men du har samtidig svart at du har opplevd negative konsekvenser av alkoholvanene dine.
                    </p>
                    <p>
                      Resultatet er både koblet til svarene om mengde og til svarene om konsekvenser. Svarene dine plasserer deg i kategorien ‘Skadelig bruk og tegn på avhengighet’. Det innebærer at drikkingen din påvirker livet ditt negativt – psykisk eller sosialt – og kan gi alvorlige fysiske konsekvenser.
                    </p>
                  </div>
                  <div v-else v-html="category.intro"></div>
                  <p v-if="checkExtraInfo(category)">
                    Du viser også tegn på avhengighet. Avhengighet kan føre til
                    at du ikke lenger klarer å bestemme hvor mye du vil drikke.
                  </p>
                  <p>
                    <span class="fancylink" @click="openModal()"
                      >Hvilke kategorier finnes i testen?</span
                    >
                  </p>
                  <modal
                    v-if="showModal"
                    @close="showModal = false"
                    bgColor="#FFCDC5"
                    color="#083650"
                  >
                    <h4>Resultatene er indelt i fem kategorier:</h4>
                    <p>
                      1. Ingen risiko<br />
                      2. Lav risiko<br />
                      3. Risikobruk<br />
                      4. Skadelig bruk<br />
                      5. Skadelig bruk og tegn på avhengighet
                    </p>
                    <p>
                      Resultatene er basert på WHOs test Audit som brukes over
                      hele verden for å kalkulere risiko og skadelige
                      alkoholvaner.
                    </p>

                    <p>
                      <a href="#" @click.prevent="showModal = false"
                        >Ok, tilbake til resultat</a
                      >
                    </p>
                  </modal>


                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="screen screen--2" id="seksjon--2">
          <div class="screen__anchor"></div>
          <div class="screen__inner">
            <div class="grid-container grid-container--small pr--0 pl--0">
              <div class="grid-x">
                <div class="small-12 cell">
                  <h2>Dine svar</h2>
                </div>
                <div class="small-12 cell" :data-interval="intervalCategory" :data-cat="category.category">
                  <div class="answers-inner">
                    <div class="flex-box" v-if="category.category==1">
                    <Icon :src="resultIconUrl()"></Icon>

                    <h3 >Vi mener du er helt uten risiko fordi:</h3>
                    </div>
                    <div class="flex-box" v-else-if="category.category==2">
                      <Icon :src="resultIconUrl()"></Icon>
                    <h3>Vi tror du har lav risiko fordi:</h3>
                    </div>
                    <div class="flex-box" v-else>
                       <Icon :src="resultIconUrl(false)"></Icon>
                      <h3>Vi tror du har et risikobruk fordi:</h3>
                    </div>

                    <div v-if="(intervalCategory == 0) && (category.category<3)">
                      <h2 class="h4">Du drikker ikke</h2>
                      <p>Du drikker ikke i det hele tatt. Å ikke drikke i det hele tatt er den eneste helt risikofrie måten å håndtere alkohol på. </p>
                    </div>
                    <div v-if="intervalCategory == 1">
                      <h2 class="h4">Ikke veldig mye eller veldig ofte</h2>
                      <p>Du drikker i gjennomsnitt <strong>{{g2aeFixed(averageGrams)}}</strong>
                        alkoholenheter (1 alkoholenhet = 12 g ren alkohol) i uken,
                        og maks <strong>{{g2aeFixed(mostGrams)}}</strong> alkoholenheter per
                        gang.</p>
                        <p>Dette er ikke veldig mye eller veldig ofte, men dessverre er
                        ingen drikking helt ufarlig. Nyere forskning viser at alkohol er
                        skadelig fra det første glasset, og at risikoen øker gradvis i takt
                        med inntaket.</p>
                        <p>Mengden du drikker, ligger likevel på det laveste
                        risikonivået. Det er bra for deg og helsen din!</p>
                    </div>
                    <div v-else-if="intervalCategory==2">
                      <h2 class="h4">Du drikker ofte.</h2>
                      <p>Du drikker i gjennomsnitt <strong>{{g2aeFixed(averageGrams)}}</strong>
                        alkoholenheter (1 alkoholenhet = 12 g ren alkohol) i uken,
                        og maks <strong>{{g2aeFixed(mostGrams)}}</strong> alkoholenheter per
                        gang.<br/>
                        Du drikker i gjennomsnitt <strong>{{averageDays}}</strong> dager i uken.</p>
                        <p>Å drikke så ofte som du gjør, vil på sikt øke risikoen for fysiske skader.</p>
                        <p>Når alkohol blir en vane i hverdagen din, kan det føre til
  avhengighet. Du risikerer etter hvert å miste kontrollen over
  drikkingen, som kan føre til uheldige konsekvenser</p>
                    </div>
                    <div v-else-if="intervalCategory==3">
                      <h2 class="h4">Du drikker mye når du drikker som mest</h2>
                        <p>Du drikker i gjennomsnitt <strong>{{g2aeFixed(averageGrams)}}</strong>
                        alkoholenheter (1 alkoholenhet = 12 g ren alkohol) i uken,
                        og når du drikker som mest,
  drikker du <strong>{{g2aeFixed(mostGrams)}}</strong> alkoholenheter.</p>
  Selv om du ikke drikker veldig
  ofte, øker risikoen når du drikker
  mye på én gang.<p>
  <p>Det er mer skadelig for kroppen
  å drikke en stor mengde på en
  gang enn å fordele den samme
  mengden over lang tid, for
  alkohol er en gift som kroppen
  trenger tid for å bryte ned.</p>
                    </div>
                    <div v-else-if="intervalCategory==4">
                      <h2 class="h4">Du drikker ofte, og du drikker mye når du drikker som mest.</h2>
                      <p>Du drikker i gjennomsnitt <strong>{{g2aeFixed(averageGrams)}}</strong>
                        alkoholenheter (1 alkoholenhet = 12 g ren alkohol) i uken,
                        og når du drikker som mest, drikker du <strong>{{g2aeFixed(mostGrams)}}</strong> alkoholenheter.<br/>
                        Du drikker i gjennomsnitt <strong>{{averageDays}}</strong> dager i uken.</p>
                        <p>Å drikke så ofte og så mye som du
                        gjør, øker risikoen for alvorlige
                        fysiske skader.</p>
                        <p>Når alkohol blir en vane i
                        hverdagen din, kan det føre til
                        avhengighet. Du risikerer å miste
                        kontrollen over drikkingen, og det
                        kan få store konsekvenser.</p>
                        <p>
                        Det er skadelig for kroppen å
                        drikke en stor mengde alkohol på
                        en gang, fordi alkohol er en gift
                        som kroppen trenger tid for å bryte
                        ned.</p>
                    </div>

                <div v-if="category.category<3">
                  <div class="small-12 cell">
                    <div v-for="answer in goodAnswers" :key="answer.id">
                      <div v-if="answerPoint(answer) == 0">
                        <div v-if="quiz.questions[answer.id].resultNot != ''">
                          <h2 class="h4">
                            {{ quiz.questions[answer.id].resultNotTitle }}
                          </h2>
                          {{ quiz.questions[answer.id].resultNot }}
                        </div>
                      </div>
                      <div v-else>
                        <h2 class="h4">
                          {{ quiz.questions[answer.id].resultTitle }}
                        </h2>
                        {{ quiz.questions[answer.id].result }}
                      </div>
                    </div>
                  </div>

                </div>
                <div v-else>
                  <div class="small-12 cell">
                    <div v-for="answer in badAnswers" :key="answer.id">
                      <div v-if="answerPoint(answer) == 0">
                        <div v-if="quiz.questions[answer.id].resultNot != ''">
                          <h2 class="h4">
                            {{ quiz.questions[answer.id].resultNotTitle }}
                          </h2>
                          {{ quiz.questions[answer.id].resultNot }}
                        </div>
                      </div>
                      <div v-else>
                        <h2 class="h4">
                          {{ quiz.questions[answer.id].resultTitle }}
                        </h2>
                        {{ quiz.questions[answer.id].result }}
                      </div>
                    </div>
                  </div>



                    </div>
                  </div>
                </div>

                <div class="small-12 cell" v-if="category.category == 2">
                      <div class="answers-inner"  v-if="badAnswers.length">
                    <div class="flex-box" v-if="(intervalCategory == 0) || ((goodAnswers.length>0) && (quiz.questions[goodAnswers[0].id].resultNot != ''))">
                          <Icon :src="resultIconUrl(false)"></Icon>
                          <h3>Men disse tingene bør du være obs på:</h3>
                        </div>

                      <div v-for="answer in badAnswers" :key="answer.id">
                        <div v-if="answerPoint(answer) == 0">
                          <div v-if="quiz.questions[answer.id].resultNot != ''">
                            <h2 class="h4">
                              {{ quiz.questions[answer.id].resultNotTitle }}
                            </h2>
                            {{ quiz.questions[answer.id].resultNot }}
                          </div>
                        </div>
                        <div v-else>
                          <h2 class="h4">
                            {{ quiz.questions[answer.id].resultTitle }}
                          </h2>
                          {{ quiz.questions[answer.id].result }}
                        </div>
                      </div>
                    </div>
                  </div>


                <div class="small-12 cell" v-if="category.category > 2">
                      <div class="answers-inner" v-if="((goodAnswers.length>0) && (quiz.questions[goodAnswers[0].id].resultNot != ''))">
                        <div class="flex-box" v-if="(intervalCategory == 0) || ((goodAnswers.length>0) && (quiz.questions[goodAnswers[0].id].resultNot != ''))">
                          <Icon :src="resultIconUrl(true)"></Icon>
                          <h3>Men du har også bra vaner:</h3>
                        </div>
                        <div v-if="(intervalCategory == 0)">
                          <h2 class="h4">Du drikker ikke</h2>
                          <p>Du drikker ikke i det hele tatt. Å ikke drikke i det hele tatt er den eneste helt risikofrie måten å håndtere alkohol på. </p>
                        </div>
                        <div v-for="answer in goodAnswers" :key="answer.id">
                          <div v-if="answerPoint(answer) == 0">
                            <div v-if="quiz.questions[answer.id].resultNot != ''">
                              <h2 class="h4">
                                {{ quiz.questions[answer.id].resultNotTitle }}
                              </h2>
                              {{ quiz.questions[answer.id].resultNot }}
                            </div>
                          </div>
                          <div v-else>
                            <h2 class="h4">
                              {{ quiz.questions[answer.id].resultTitle }}
                            </h2>
                            {{ quiz.questions[answer.id].result }}
                          </div>
                        </div>
                      </div>
                    </div>






              </div>
            </div>
          </div>
        </div>

        <div class="screen screen--3" id="seksjon--3">
          <div class="screen__anchor"></div>
          <div class="screen__inner">
            <div class="grid-container grid-container--small pr--0 pl--0">
              <div class="grid-x">
                <div class="small-12 cell" >
                  <h2 v-if="category.category < 3">Gode drikkevaner</h2>
                  <h2 v-else>Slik kan du drikke smartere</h2>

                  <div v-if="mostGrams==0">
                    <p v-if="category.category == 1">
                      Her pleier vi å tipse om hvordan man kan drikke smartere.
                      Men det aller smarteste er å ikke drikke i det hele tatt, og
                      det gjør du allerede. Lurt valg!
                    </p>
                    <p v-else>
                      Du opplever negative konsekvenser av alkohol, men oppgir samtidig at du ikke drikker.
                    </p>
                  </div>
                  <div v-else-if="category.category == 2">
                    <p v-if="intervalCategory==1">Du drikker ikke veldig mye, og det er bra! Nyere forskning viser likevel at risiko for skade øker gradvis jo mer man drikker, allerede fra første glass. Å drikke litt alkohol iblant trenger ikke være skadelig, men ikke drikk alkohol for helsens skyld.
                    </p>
                    <p v-else-if="intervalCategory==2">
                      Du har mye å tjene på å drikke sjeldnere.
                    </p>
                    <p v-else-if="intervalCategory==3">
                      Du kan tjene på å drikke mindre når du drikker som mest.
                    </p>
                    <p v-else-if="intervalCategory==4">
                      Du har mye å tjene på å drikke mindre, både ved å drikke en mindre mengde alkohol per
gang, og ved å drikke sjeldnere.
                    </p>
                  </div>

                  <div v-else>
                    <p v-if="intervalCategory==1">Du oppgir ikke et veldig høyt forbruk av alkohol, men du opplever negative konsekvenser av alkoholbruket. Her kan du sjekke ut fordelene ved å ikke drikke. Ved stadig lavere alkoholforbruk vil sannsynligvis de negative konsekvensene forsvinne.
                    </p>
                    <p v-else-if="intervalCategory==2">
                      Du har mye å tjene på å drikke sjeldnere.
                    </p>
                    <p v-else-if="intervalCategory==3">
                      Du kan tjene på å drikke mindre når du drikker som mest.
                    </p>
                    <p v-else-if="intervalCategory==4">
                      Du har mye å tjene på å drikke mindre, både ved å drikke en mindre mengde alkohol per
gang, og ved å drikke sjeldnere.
                    </p>
                  </div>
                </div>

                <div
                  class="small-12 cell"
                  v-for="(table, index) in allTables"
                  :key="index"
                >
                  <h2 class="h4">{{ table.title }}</h2>
                  <Hints :allHints="table.data"></Hints>
                </div>


                <div class="small-12 cell" >
                  <div v-if="mostGrams==0">
                    <p v-if="category.category == 1">
                      <a target="_blank" href="/slik-kan-du-fa-bedre-drikkevaner/">Her kan du lese om hvordan man kan drikke smartere.</a>
                    </p>
                    <p v-else>
                      <a target="_blank" href="/slik-kan-du-fa-bedre-drikkevaner/">Her kan du lese om hvordan man kan drikke smartere.</a>
                    </p>
                  </div>
                  <div v-else-if="category.category == 2">
                    <p v-if="intervalCategory==1">
<a target="_blank" href="/slik-kan-du-fa-bedre-drikkevaner/">Her kan du lese om hvordan man kan drikke smartere.</a>
                    </p>
                    <p v-else>
                      <a target="_blank" href="/ti-fordeler-ved-a-drikke-mindre-alkohol/">Her kan du sjekke ut fordelene ved å drikke mindre alkohol.</a>
                    </p>
                  </div>

                  <div v-else>
                    <p v-if="intervalCategory==1">
<a target="_blank" href="/slik-kan-du-fa-bedre-drikkevaner/">Her kan du lese om hvordan man kan drikke smartere.</a>
                    </p>
                    <p v-else>
                      <a target="_blank" href="/ti-fordeler-ved-a-drikke-mindre-alkohol/">Her kan du sjekke ut fordelene ved å drikke mindre alkohol.</a>
                    </p>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div
          class="screen screen--4"
          id="seksjon--4"
          v-if="category.category > 3"
        >
          <div class="screen__anchor"></div>
          <div class="screen__inner">
            <div class="grid-container grid-container--small pr--0 pl--0">
              <div class="grid-x">
                <div class="small-12 cell"></div>

                <div class="small-12 cell">
                  <h2>
                    Slik kan du ta grep
                  </h2>
                  <p>
                    Mange kan klare å redusere alkoholkonsumet sitt på egen
                    hånd. Her er det noen verktøy som kan hjelpe deg på veien.
                  </p>
                  <div class="card">
                    <p>1. Finn risikosituasjoner</p>
                    <p>
                      Å reflektere over hvilke situasjoner som er problematisk
                      for deg når det kommer til alkohol, kan hjelpe deg til å
                      finne måter å håndtere dem annerledes. Dette verktøyet kan
                      hjelpe deg.
                    </p>

                    <p>
                      <a
                        class="fancylink"
                        href="/content/plugins/promillekalkulator/avogtil-drikkevaner/assets/pdf/Finn-risikosituasjoner.pdf"
                        target="_blank"
                        title="Last ned Finn risikosituasjoner"
                        >Last ned Finn risikosituasjoner</a
                      >
                    </p>
                  </div>
                  <div class="card">
                    <p>2. Definer mål</p>
                    <p>
                      Å sette seg må for å kunne redusere eget alkoholforbruk er
                      et godt sted å starte. Det hjelper deg med å få en klar
                      oppfatning av hva du ønsker å oppnå, og du ser også egne
                      framskritt. Dette verktøyet kan hjelpe deg.
                    </p>

                    <p>
                      <a
                        class="fancylink"
                        href="/content/plugins/promillekalkulator/avogtil-drikkevaner/assets/pdf/Maal-for-aa-redusere-alkoholinntak.pdf"
                        target="_blank"
                        title="Last ned Definer mål"
                        >Last ned Definer mål</a
                      >
                    </p>
                  </div>
                  <div class="card">
                    <p>3. Alkoholkalenderen</p>
                    <p>
                      Som du kanskje la merke til da du gjorde testen, kan det
                      være vanskelig å huske akkurat hvor mye alkohol du har
                      drukket. Derfor kan det være lurt å fylle ut en
                      alkoholkalender hver dag. Da får du et realistisk bilde av
                      dine alkoholvaner.
                    </p>

                    <p>
                      <a
                        class="fancylink"
                        href="/content/plugins/promillekalkulator/avogtil-drikkevaner/assets/pdf/Alkoholkalenderen.pdf"
                        target="_blank"
                        title="Last ned Alkoholkalender"
                        >Last ned Alkoholkalender</a
                      >
                    </p>
                  </div>
                  <div class="card">
                    <p>4. Plan for en alkoholfri periode</p>
                    <p>
                      Mange har nytte av å ta en periode helt uten alkohol. Det
                      gjør at man lettere reflekterer over alkoholens påvirkning
                      i livet. Det gjør det også lettere å legge merke til de
                      positive effektene av å ikke drikke. Med dette verktøyet
                      kan du lage deg din egen plan.
                    </p>

                    <p>
                      <a
                        class="fancylink"
                        href="/content/plugins/promillekalkulator/avogtil-drikkevaner/assets/pdf/Plan-for-aa-drikke-sjeldnere.pdf"
                        target="_blank"
                        title="Last ned Plan for en alkoholfri periode"
                        >Last ned Plan for en alkoholfri periode</a
                      >
                    </p>
                  </div>
                  <div class="card">
                    <p>5. Plan for å drikke kontrollert</p>
                    <p>
                      Er målet ditt å kontrollere mengden alkohol du drikker?
                      Dette verktøyet kan hjelpe deg.
                    </p>

                    <p>
                      <a
                        class="fancylink"
                        href="/content/plugins/promillekalkulator/avogtil-drikkevaner/assets/pdf/Plan-for-aa-drikke-kontrollert.pdf"
                        target="_blank"
                        title="Last ned Plan for å drikke kontrollert"
                        >Last ned Plan for å drikke kontrollert</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="screen screen--5" id="seksjon--5">
          <div class="screen__anchor"></div>
          <div class="screen__inner">
            <div class="grid-container grid-container--small pr--0 pl--0">
              <div class="grid-x">
                <div class="small-12 cell"></div>

                <div class="small-12 cell" v-if="category.category > 3">
                  <h2>
                    Nå vet du mer om din drikkestatus og hvordan det påvirker deg og andre
                  </h2>
                  <p>
                    Ble resultatet en tankevekker for deg? Husk at du er den eneste som kan ta grep om din drikking. Snakk gjerne med noen om resultatet du har fått her og hva du vil gjøre nå. Det kan gjøre veien videre enklere!
                  </p>
                </div>
                <div class="small-12 cell" v-else-if="category.category == 3">
                  <h2>
                    Nå vet du mer om din drikkestatus og hvordan det påvirker deg og andre
                  </h2>
                  <p>
                    Husk at hvert ekstra glass du drikker øker risikoen for negative konsekvenser, for eksempel for din egen helse. Myndighetenes råd er å begrense alkoholinntaket, unngå å drikke deg beruset og å ikke drikke for helsens skyld.
                  </p>


                </div>
                 <div class="small-12 cell" v-else-if="category.category == 2">
                  <h2>
                    Takk for at du testet din drikkestatus
                  </h2>
                  <p>
                    Bruk alkovett, det er bra for deg og de rundt deg! Og tips gjerne en venn som vil sjekke sin drikkestatus.
                  </p>

                </div>
                 <div class="small-12 cell" v-else-if="category.category == 1">
                  <h2>
                    Takk for at du testet din drikkestatus
                  </h2>
                  <p>
                    Fortsett å leve alkoholfritt - både helsen din og de rundt deg vil takke deg! Og tips gjerne en venn som vil sjekke sin drikkestatus.
                  </p>


                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="slide">
        <div class="grid-container grid-container--small" id="seksjon--7">
          <div class="grid-x">
            <section class="text">
              <div class="text__content">
                <h2>Ta vare på resultatet ditt</h2>
                <p>
                 Lagre denne lenken hvis du vil se resultatet og tipsene igjen. Hvis du deler linken med andre kan de se resultatet ditt og hva du har svart på spørsmålene.
                </p>
                <label>Din personlige lenke:</label>

                  <form @submit.prevent="copyLink" class="resultForm">
                    <div class="grid-x grid-padding-x">
                    <div class="small-12 medium-8 input">

                      <input placeholder="" id="url" type="text" :value="getResultsUrl" required />
                    </div>

                    <div class="small-12 medium-4">
                    <button :disabled="sending" :class="[name ? activeClass : '']" type="submit">
                      <span>Kopier lenken</span>
                    </button>
                    </div>

                  </form>
                <label v-if="copied">{{ copied }}</label>
              </div>
            </section>
          </div>
        </div>
        <div class="grid-container grid-container--small"  id="seksjon--6" v-if="category.category > 2">
          <div class="grid-x">
            <section class="text">
              <div
                class="text__content"
                data-toggled-by="text-0.61455000 1603463964"
              >
                <h2>Vil du snakke med noen etter å ha tatt testen?</h2>
                <p>
                 Det kan være lurt å snakke med noen dersom du har spørsmål eller tanker. Vi anbefaler disse:
                </p>
              </div>
            </section>
          </div>
        </div>
        <div class="grid-container grid-container--small" v-if="category.category > 2">
          <div class="grid-x">
            <ul class="accordion">
              <li
                class="accordion__element js--accordion-element"
                data-number="accordion-0.61493400 1603463964"
              >
                <a href="#" class="accordion__element__header h5 mt--0 mb--0">
                  <h2>Fastlegen din</h2>

                  <span class="accordion__element__header__icon"></span>
                </a>

                <div class="accordion__element__body">
                  <div class="accordion__element__body__inner">
                    <p>
                      Om du opplever at alkoholen er i ferd med å ta overhånd,
                      kan det være lurt å snakke med fastlegen din, eller andre
                      du stoler på. Les mer&nbsp;<a
                        href="/fakta/drikker-jeg-for-mye/"
                        >her</a
                      >.
                    </p>
                  </div>
                </div>
              </li>

              <li
                class="accordion__element js--accordion-element"
                data-number="accordion-0.61514900 1603463964"
              >
                <a href="#" class="accordion__element__header h5 mt--0 mb--0">
                  <h2>Rustelefonen</h2>

                  <span class="accordion__element__header__icon"></span>
                </a>

                <div class="accordion__element__body">
                  <div class="accordion__element__body__inner">
                    <p>
                      På&nbsp;<a href="http://www.rustelefonen.no/"
                        >Rustelefonen</a
                      >
                      915 08588 kan man få svar på alle spørsmål om alkohol og
                      rus. Her kan man også chatte eller sende inn spørsmål.
                    </p>
                  </div>
                </div>
              </li>

              <li
                class="accordion__element js--accordion-element"
                data-number="accordion-0.61533700 1603463964"
              >
                <a href="#" class="accordion__element__header h5 mt--0 mb--0">
                  <h2>Kirkens SOS</h2>

                  <span class="accordion__element__header__icon"></span>
                </a>

                <div class="accordion__element__body">
                  <div class="accordion__element__body__inner">
                    <p>
                      Ved å ringe&nbsp;<a href="https://www.kirkens-sos.no/"
                        >Kirkens SOS</a
                      >&nbsp;på 22 40 00 40 kan du snakke med noen om det du
                      skulle ønske. Tjenesten er døgnåpen. Her kan man også
                      chatte eller skrive inn melding.
                    </p>
                  </div>
                </div>
              </li>

              <li
                class="accordion__element js--accordion-element"
                data-number="accordion-0.61554600 1603463964"
              >
                <a href="#" class="accordion__element__header h5 mt--0 mb--0">
                  <h2>Mental Helse Hjelpetelefonen</h2>

                  <span class="accordion__element__header__icon"></span>
                </a>

                <div class="accordion__element__body">
                  <div class="accordion__element__body__inner">
                    <p>
                      Mental Helse har en telefon- og nettjeneste for alle som
                      trenger noen å snakke med på 116 123 eller&nbsp;<a
                        href="https://mentalhelse.no/fa-hjelp/hjelpetelefonen"
                        ><span class="txt-blue-medium"
                          >mentalhelse.no.&nbsp;</span
                        ></a
                      ><span class="txt-blue-medium"
                        >Fra&nbsp;utlandet må du ringe +47 91 116
                        123.&nbsp;</span
                      >
                    </p>
                  </div>
                </div>
              </li>

              <li
                class="accordion__element js--accordion-element"
                data-number="accordion-0.61575600 1603463964"
              >
                <a href="#" class="accordion__element__header h5 mt--0 mb--0">
                  <h2>Blå Kors</h2>

                  <span class="accordion__element__header__icon"></span>
                </a>

                <div class="accordion__element__body">
                  <div class="accordion__element__body__inner">
                    <p>
                      Blå Kors tilbyr hjelp og behandling til både pårørende og
                      til deg som har et vanskelig forhold til rus.
                      <a
                        href="https://www.blakors.no/virksomheter-og-tilbud/"
                        target="_blank"
                        rel="noopener"
                        >Se oversikt over tilbudet deres her.</a
                      >
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="mt--section mb--section flex--medium two-arts">

            <a style="background-image:url(/content/plugins/promillekalkulator/avogtil-drikkevaner/assets/pexels-photo.jpg)"
            href="/alkohol-og-helse/"
            title="Alkohol og helse" target="" class="splitLink">
                <div class="title">
                    <div>Alkohol og helse</div>

                </div>
            </a>



            <a style="background-image:url(/content/plugins/promillekalkulator/avogtil-drikkevaner/assets/07_optimized.jpg)"
             href="/hjelp-med-alkohol/drikker-en-du-er-glad-i-for-mye/"
             title="Drikker en du er glad i for mye?" target="" class="splitLink">
                <div class="title">
                    <div>Drikker en du er glad i for mye?</div>

                </div>
            </a>

        </div>
      </div>


    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import results from "../appdata/results.js";
import quiz from "../appdata/quiz.js";
import Hints from "./common/Hints";

import hints from "../appdata/hints.js";
import tables from "../appdata/tables.js";
import Modal from "./common/ModalGeneric";
import Icon from "./common/Icon";

export default {
  data() {
    return {
      hintArr: hints,
      tables: tables,
      quiz: quiz,
      id: null,
      day: null,
      categoryId: null,
      showModal: false,
      activeClass: "active",
      copied: '',
    };
  },
  components: {
    Hints: Hints,
    Modal: Modal,
    Icon: Icon,
  },
  computed: {
    ...mapGetters([
      "getTotal",
      "getAlcoholPoints",
      "getSex",
      "getAnswers",
      "getEmployment",
      "getResultsUrl",
    ]),
    anyAnswers(){
        let filtered = this.getAnswers;
        filtered.sort((a, b) => {
          return a.id - b.id;
        });
        return filtered;
    },
     goodAnswers(){
        let filtered = this.getAnswers.filter((answer) => !answer.value);
        filtered.sort((a, b) => {
          return a.id - b.id;
        });
        return filtered;
     },
     badAnswers(){
        let filtered = this.getAnswers.filter((answer) => answer.value);
        filtered.sort((a, b) => {
          // grandparents always last
          if(a.id == 7){
            return 1;
          }
          if (b.id == 7){
            return -1;
          }
          if(b.value==a.value){
            return a.id - b.id;
          } else {
            return b.value - a.value
          }
        });
        return filtered;
     },
     calendarDays() {
      if (Array.isArray(this.$store.state.calendar)) {
        return this.$store.state.calendar.filter((day) => day.alcohol > 0)
          .length;
      } else {
        return 0;
      }
    },
    lotsGrams() {
      return this.countG(this.$store.state.lotsAlcohols);
    },
    littleGrams() {
      return this.countG(this.$store.state.littleAlcohols);
    },
    otherGrams() {
      return this.countG(this.$store.state.otherAlcohols);
    },
     calendarLotsDays() {
      if (Array.isArray(this.$store.state.calendar)) {
        return this.$store.state.calendar.filter((day) => day.alcohol == 2)
          .length;
      } else {
        return 0;
      }
    },
    calendarLittleDays() {
      if (Array.isArray(this.$store.state.calendar)) {
        return this.$store.state.calendar.filter((day) => day.alcohol == 1)
          .length;
      } else {
        return 0;
      }
    },
    averageGrams() {
      return (this.lotsGrams*this.calendarLotsDays + this.littleGrams*this.calendarLittleDays + this.otherGrams) / 4;

    },
    mostGrams() {
      return Math.max(this.lotsGrams, this.littleGrams, this.otherGrams);
    },
    averageDays() {
      return this.calendarDays / 4;
    },
    intervalCategory(){


      if(this.mostGrams == 0){
        return 0;
      }
      if(!this.isAboveLimit()){
        if(this.calendarDays < 13 ){
          return 1; // 2a 3a
        } else {
          return 2; // 2a 3b
        }
      } else {
        if(this.calendarDays < 13 ){
          return 3; // 2b 3a
        } else {
          return 4; // 2b 3b
        }
      }


    },
    category() {
      if (typeof this.getSex !== "undefined") {
        let categoryId = this.getCategoryId();

        return results[categoryId];
      }
      return false;
    },
    allHints() {
      let categoryHints = this.hintArr[this.getCategoryId()];
      if (this.getEmployment == "student") {
        return categoryHints["student"];
      } else if (this.getEmployment == "retired") {
        return categoryHints["retired"];
      } else {
        return categoryHints["default"];
      }
    },
    allTables() {
      let tables = [];
      let names = ["good", "much", "often"];
      let pointer = this.allHints.length == 3 ? 0 : 1;

      if((this.mostGrams == 0)
      || (!this.isAboveLimit() && (this.calendarDays < 13))){
         tables.push(this.tables[this.allHints[0] - 1]);
         return tables;
      }
      if(this.isAboveLimit()){
        tables.push(this.tables[this.allHints[1] - 1]);
      }
      if(this.calendarDays > 12 ){
         tables.push(this.tables[this.allHints[2] - 1]);
      }
      return tables;

    },
  },
  methods: {
    resultIconUrl(good = true){
      let url = mainsite_phptojs.themeUrl + '/avogtil-drikkevaner/assets/';
      if((this.getSex != '') && (this.getEmployment!='')){
      url += this.getSex;
      url += '_';
      url += this.getEmployment;
      } else {
        url+='none_other';
      }
      console.log(good);
      url += good ? '_happy' : '_skuffet';
      console.log(url);
      url += '.svg';
      return url;
    },
    isAboveLimit(){
      let limit = 60;
      if (typeof this.getSex !== "undefined") {
        switch(this.getSex){
          case 'female':
            limit = 48;
            break;
          case 'none':
            limit = 55;
            break;
        }
      }
      return this.mostGrams >= limit;
    },
    copyLink(){
      let testingCodeToCopy = document.querySelector('#url')
          testingCodeToCopy.setAttribute('type', 'text')
          testingCodeToCopy.select()

          try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            this.copied = 'Lenken ble kopiert';
          } catch (err) {
            this.copied = 'Oi, lenken kunne ikke kopieres';
          }

          /* unselect the range */
          //testingCodeToCopy.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()

    },
    countG(alcohols) {
      let sum = 0;
      if (alcohols.length) {
        let self = this;
        alcohols.forEach(function(value, index) {
          if (typeof value.volume !== "undefined") {
            sum +=
              self.countGrams(value.volume, value.percentage) * value.quantity;
          }
        });

        return sum;
      }
      return 0;
    },
    // Alcohol in grams (dl * Vol% * 0.8) (amount * strength * 0.8)
    countGrams(dl, vol) {
      return parseFloat(dl) * parseFloat(vol) * 0.8;
    },
    g2ae(grams) {
      return grams / 12;
    },
    g2aeFixed(grams) {
      let ae = this.g2ae(grams);
      if(ae < 1){
        return ae.toFixed(2);
      }
      return ae.toFixed(1);
    },

    openModal() {
      this.showModal = true;
    },
    answerPoint(item){
      let answer = quiz.questions[item.id].responses.filter(
        (answer) => answer.value == item.value
      );
      return answer[0].points;
    },
    checkExtraInfo(category) {
      let answerPoints = 0;
      let _self = this;
      this.getAnswers.forEach(function(item) {
        if (item.id < 3) {
          answerPoints += _self.answerPoint(item);
        }
      });
      return (
        answerPoints > 4 && (category.catgory == 3 || category.category == 4)
      );
    },
    saveResults(){
      this.$eventBus.$emit("saveResults", true);
    },
    getCategoryId() {
      switch (this.getSex) {
        case "male":
          if (this.getTotal == 0) {
            return 0;
          } else if (this.getTotal < 8) {
            return 1;
          } else if (this.getTotal < 16) {
            return 2;
          } else if (this.getTotal < 20) {
            return 3;
          } else {
            return 4;
          }
          break;
        case "female":
          if (this.getTotal == 0) {
            return 0;
          } else if (this.getTotal < 6) {
            return 1;
          } else if (this.getTotal < 14) {
            return 2;
          } else if (this.getTotal < 18) {
            return 3;
          } else {
            return 4;
          }
          break;
        default:
          if (this.getTotal == 0) {
            return 0;
          } else if (this.getTotal < 7) {
            return 1;
          } else if (this.getTotal < 15) {
            return 2;
          } else if (this.getTotal < 19) {
            return 3;
          } else {
            return 4;
          }
          break;
      }
    },
  },
  mounted() {
    this.saveResults();
    this.$ga.event('avogtil', 'quiz', 'fullført');
    var j$ = jQuery,
      $nav = j$("#submenu"),
      $navUl = j$("#submenu ul"),
      $slideLine = j$("#slide-line"),
      $currentItem = j$(".active");

    j$(document).ready(function() {
      j$(document).on("scroll", onScroll);
      var currLink = j$("#submenu a").first();
      currLink.addClass("active");
      $slideLine.css({
        width: currLink.parent("li").width(),
        left: currLink.parent("li").position().left,
      });

      j$.fn.scrollEnd = function(callback, timeout) {
        j$(this).scroll(function(){
          var j$this = j$(this);
          if (j$this.data('scrollTimeout')) {
            clearTimeout(j$this.data('scrollTimeout'));
          }
          j$this.data('scrollTimeout', setTimeout(callback,timeout));
        });
      };

      // how to call it (with a 1000ms timeout):
      j$(window).scrollEnd(function(){
          slideActive();
           var scrollPos = j$(document).scrollTop();
          if(snapDiv.length){
            if (direction == 'down'){
              if(scrollPos < (snapDiv.position().top - 152)){
                j$('html, body').animate({
                  scrollTop: (snapDiv.position().top - 150)
                }, 800);
              }

            }
          }
      }, 100);
    });

    function slideActive(){
      let currLink = j$("#submenu ul li a.active");
      if(currLink.length==1){

        let left = j$("#submenu ul li a.active").parent("li").position().left;
        let scrollLeft = $navUl.scrollLeft();

        $navUl.scrollLeft(left+scrollLeft-j$(window).width()/2 + currLink.width()/2 );
        $slideLine.css({
            width: currLink.parent("li").width(),
            left: currLink.parent("li").position().left,
          });

      }
    }
    var lastScrollTop = 0;
    var direction = '';
    var snapDiv = j$("#seksjon--1");
    function onScroll(event) {
      var scrollPos = j$(document).scrollTop();
      let href = (j$("#submenu ul li:first-child a").attr('href'));
      if(typeof href != 'undefined'){
        var myfirst = j$(href).position().top;


        var found = false;
        slideActive();
        j$("#submenu a").each(function() {
          var currLink = j$(this);
          var refElement = j$(currLink.attr("href"));
          if (
            refElement.position().top - 200 <= scrollPos &&
            refElement.position().top + refElement.outerHeight() - 200 > scrollPos
          ) {
            j$("#submenu ul li a").removeClass("active");
            currLink.addClass("active");

            $slideLine.css({
              width: currLink.parent("li").width(),
              left: currLink.parent("li").position().left,
            });
            found = true;
          } else {
            currLink.removeClass("active");
          }
        });
        if (!found) {
          if (myfirst > scrollPos) {
            var currLink = j$("#submenu a").first();

            currLink.addClass("active");
            $slideLine.css({
              width: currLink.parent("li").width(),
              left: currLink.parent("li").position().left,
            });
          } else {
            var currLink = j$("#submenu ul li:last-child a").first();
            currLink.addClass("active last");
            $slideLine.css({
              width: currLink.parent("li").width(),
              left: currLink.parent("li").position().left,
            });
          }
          if (scrollPos + j$(window).height()  == j$(document).height()) {
            var currLink = j$("#submenu ul li:last-child a").first();
            currLink.addClass("active outlast");
            $slideLine.css({
              width: currLink.parent("li").width(),
              left: currLink.parent("li").position().left,
            });
          }

        }
      }
      if (scrollPos > lastScrollTop){
        direction = 'down';
      } else {
        direction = 'up';
      }

      lastScrollTop = scrollPos;
    }
    this.day = this.item;

    j$(function() {
      // Menu has active item
      if ($currentItem[0]) {
        $slideLine.css({
          width: $currentItem.width(),
          left: $currentItem.position().left,
        });
      }

      // Underline transition
      j$($nav)
        .find("li")
        .hover(
          // Hover on
          function() {
            $slideLine.css({
              width: j$(this).width(),
              left: j$(this).position().left,
            });
          },
          // Hover out
          function() {
            if ($currentItem[0]) {
              // Go back to current
              $slideLine.css({
                width: $currentItem.width(),
                left: $currentItem.position().left,
              });
            } else {
              // Disapear
              $slideLine.width(0);
            }
          }
        );
    });
  },
};

//http://avogtil.test/habits-kalkulator/#/17/?m=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
</script>

<style lang="scss">
.scrolldown {
  bottom: 90px;
}
.screen__inner {
  height: auto;
}
.screen__anchor {
  &:after {
    top: calc(136px - 2.25rem);
  }
}
.screen {
  align-items: top;
  -webkit-box-align: top;
  height: auto;
  &:first-child {
    @media screen and (min-width:960px){
    height: 100vh;
    }

    .screen__anchor {
      &:after {
        top: calc(50% - 2.25rem);
      }
    }
  }
  &:last-child {
    .screen__anchor {
      &:after {
        top: calc(50% - 2.25rem);
      }
      &:before {
        height: calc(50% - 2.25rem);
      }
    }
  }
  @media screen and (max-width:959px){
    &:first-child {
      padding-top:9rem;
      .screen__anchor {
        &:after {
          top: 9.75rem;
        }
        &:before{
          height: calc(100% - 9.75rem - 16px)
        }
      }
    }
    .screen__anchor {
        &:after {
          top: calc(150px - 2.25rem);
        }
    }

  }
@media screen and (max-width:639px){
  .screen__anchor {
        &:after {
          top: calc(117px - 2.25rem);
        }
    }
}
}
.card {
  background: #f9efe7;
  color: #083650;
  max-width: 540px;
  padding: 1.5rem;
  margin-top: 30px;
  border-radius: 4px;
}
#submenu-container {
  position: fixed;
  top: 60px;
  padding-top: 1.5rem;
  left: 0;
  padding-left: 1.5rem;
  max-width: 100%;
  z-index: 5;
  overflow: hidden;
  .goBack{
    color:#fff;
    padding-bottom:1rem;
    button{
       .icon{
        background-position:left center;
            width: 1.125rem;
            background-size:100%;
      }
      &:hover{
        color:#EF5050;
      .icon{
        transform:none;
      }
    }
    }
    @media screen and (min-width: 111750px) {
      padding-bottom:1rem;
      position:fixed;
      bottom:1.5rem;
      left:1.5rem;

    }
  }
  //max-width: 1749px) {
    top: 50px;
    background: #083650;
    text-align: center;
    padding-left: 0;
    right: 0;
    .center {
      margin: 0 auto;
      display: inline-block;
      max-width: 100%;
      padding-left: 1.5rem;
    }

}
#submenu {
  position: relative;
  ul {
    list-style-type: none;
    overflow: auto;

    max-width: 100%;
    margin: 0;
  }
  // @media screen and (max-width: 1749px) {
    margin: 0;

    &:after {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: #ffcdc5;
      border-radius: 2px;
      height: 5px;
      content: "";
      z-index: 5;
    }
    #slide-line {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: #ef5050;
      border-radius: 2px;
      height: 5px;
      content: "";
      z-index: 6;
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;
      width: 120px;
    }
    ul {
      margin: 0;
      position: relative;
      overflow: auto;
      white-space: nowrap;

      li {
        float: none;
        display: inline-block;
        margin: 0 1.5rem 0 0;
        &:last-child {
          margin-right: 0;
        }
        padding-bottom: 1rem;
        position: relative;
        a {
          text-decoration: none;
          color: #fff;
          &:hover,
          &.active {
            color: #ef5050;
          }
        }
      }
    }
  //}
  @media screen and (min-width: 111750px) {
    width: 205px;
    z-index: 5;
    border-radius: 4px;
    background: #fad283;
    ul {
      padding: 2rem 0.75rem;
      a {
        display: block;
        padding-left: 0.75rem;
        padding-right: 0.75rem;
        color: #083650;
        position: relative;
        &.active,
        &:hover {
          &:before {
            position: absolute;
            left: 0;
            top: 10px;
            width: 8px;
            height: 8px;
            background: #083650;
            border-radius: 50%;
            content: "";
          }
        }
      }
    }
  }
}
.resultForm {

  input {
    border: 0;
    border-bottom: 2px solid #748994;
     &:active, &:focus{
      border:0;
      border-bottom: 2px solid #748994;
    }
  }
  @media screen and (min-width:640px){
    button{
      width:80%;
      float:right;
      max-width: 100%;
      padding: 0;
      text-align: center;

    }
  }
  label input{
    margin-left:2px;
  }
  label.error{
    color:#EF5050;
    input{
      outline:2px solid #EF5050
    }
  }
}
input::placeholder, textarea::placeholder {

    color: #748994;

}
.two-arts{

  a {
    font-size:30px;
    height:70vh;
    @media screen and (max-width:767px){
      height:40vh;
    }

    background-size:cover;
    color:#fff;
    position:relative;
    text-align:left;
    &:hover{
      color:#EF5050
    }
    .title{
      position:absolute;
      left:0px;
      bottom:0px;
      right:0;
      padding:2.5rem;
      @media screen and (max-width:1023px){
        padding: 32px 24px;
        font-size:80%;
      }
      div{
        position:relative;
      z-index:4;
      }
      &:before{
        content: "";
        background: -webkit-gradient(linear,left top,left bottom,from(transparent),to(rgba(0,0,0,.8)));
        background: linear-gradient(180deg,transparent,rgba(0,0,0,.8));
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index:3;
      }
    }
  }

}
.resultat-icon {
	background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNDQuOSAxNTIuMjciPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjdlZWU1O30uY2xzLTJ7ZmlsbDojODJjN2IyO30uY2xzLTN7ZmlsbDojZmFkMjgzO308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEwMC40NCwyNS4xOWgwYTYuMzUsNi4zNSwwLDAsMS0xLjg2LTQuNDd2LTEySDkuNzVBMS4xNSwxLjE1LDAsMCwwLDksOUw5LDlhMS4xNSwxLjE1LDAsMCwwLS4zLjc2VjE0Mi41MmExLjA3LDEuMDcsMCwwLDAsLjMyLjc2SDlhMS4xMSwxLjExLDAsMCwwLC43Ny4zMUgxMTEuMzZhMS4wOSwxLjA5LDAsMCwwLDEuMDgtMS4wOHYtNS4yN2gwVjczLjU5aDBWMjdoLTcuNTNBNi4zNCw2LjM0LDAsMCwxLDEwMC40NCwyNS4xOVpNMjMuMyw5Ni43OWEyLjU1LDIuNTUsMCwwLDEsMi41NC0yLjU0SDcxLjcxbC0uMDYuMTVoMGwwLC4wNy0uMTMuMzEsMCwuMDgtLjA5LjIzLS4xNS4zOS0uMDguMjItLjE0LjQtLjA4LjI0LDAsLjA4LDAsLjA3LDAsLjA4LDAsLjA4LDAsLjA4LS4xLjMyLDAsLjA4LDAsLjA4LDAsLjA4LDAsLjA4LS4xMS40LDAsLjA4LDAsLjA5LDAsLjA4YzAsLjEzLS4wOC4yNy0uMTEuNGwwLC4wOCwwLC4wOSwwLC4wOGgwbC0uMDkuNDEsMCwuMDgsMCwuMDgsMCwuMDhIMjUuODRBMi41NCwyLjU0LDAsMCwxLDIzLjMsOTYuOFpNMjUuODQsMTIwYTIuNTQsMi41NCwwLDAsMS0yLjU0LTIuNTRoMGEyLjU1LDIuNTUsMCwwLDEsMi41NC0yLjU0SDcxLjJsMCwuMDkuMTUuMzguMDkuMjMuMTUuMzgsMCwuMDguMDYuMTYuMTcuMzguMTIuMjcuMTIuMjUsMCwuMDgsMCwwLC4xMy4yOGgwbDAsLjA4LDAsLjA3LDAsLjA4LDAsLjA4LjE2LjMyLDAsLjA4LDAsLjA3LDAsLjA4LjIxLjM5aDBsMCwuMDgsMCwuMDcsMCwuMDguMTguMywwLC4wOC4wNS4wOCwwLC4wN2MuMDcuMTMuMTUuMjUuMjMuMzhsMCwuMDdabTcyLTQzLjg1YTIuNDksMi40OSwwLDAsMS0uMjUsMS4wOWgtLjgzbC0uNzEsMGgwbC0uNywwaDBsLS42Ny4wNmgtLjA1bC0uNjQuMDdoLS4wN2wtLjYuMDgtLjEzLDAtLjU5LjFoLS4wN2wtLjU4LjEyLS4xNCwwLS41Ni4xMy0uMTIsMC0uNTMuMTMtLjE4LDAtLjUxLjE0LS4xMSwwLS41LjE1LS4yLjA2LS40OC4xNkgyNS44NGEyLjU1LDIuNTUsMCwwLDEtMi41NC0yLjU0aDBhMi41NSwyLjU1LDAsMCwxLDIuNTQtMi41NEg5NS4yN2EyLjU1LDIuNTUsMCwwLDEsMi41NCwyLjU0Wm0wLTIwLjY2QTIuNTUsMi41NSwwLDAsMSw5NS4yNyw1OEgyNS44NGEyLjU1LDIuNTUsMCwwLDEtMi41NC0yLjU0aDBhMi41NCwyLjU0LDAsMCwxLDIuNTQtMi41NEg5NS4yN2EyLjU0LDIuNTQsMCwwLDEsMi41NCwyLjU0Wm0wLTIwLjY2YTIuNTUsMi41NSwwLDAsMS0yLjU0LDIuNTRIMjUuODRhMi41NSwyLjU1LDAsMCwxLTIuNTQtMi41NGgwYTIuNTQsMi41NCwwLDAsMSwyLjU0LTIuNTRIOTUuMjdhMi41NCwyLjU0LDAsMCwxLDIuNTQsMi41NFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0xMTMsMTIuNDEsMTA1LDEuNzQsMTAzLjY5LDBIOS43NUE5LjczLDkuNzMsMCwwLDAsMi44OCwyLjg2bDAsMEE5LjcyLDkuNzIsMCwwLDAsMCw5Ljc1VjE0Mi41MmE5Ljc2LDkuNzYsMCwwLDAsMi44Niw2Ljg5aDBhOS43Myw5LjczLDAsMCwwLDYuODcsMi44NkgxMTEuMzZhOS43Niw5Ljc2LDAsMCwwLDkuNzUtOS43NVYyNC43OGwtLjg2LTIuNTlabS0uNTEsNjEuMThoMHY2My42NmgwdjUuMjdhMS4wOSwxLjA5LDAsMCwxLTEuMDgsMS4wOEg5Ljc1YTEuMTEsMS4xMSwwLDAsMS0uNzctLjMxSDlhMS4wNywxLjA3LDAsMCwxLS4zMi0uNzZWOS43NUExLjE1LDEuMTUsMCwwLDEsOSw5TDksOWExLjE1LDEuMTUsMCwwLDEsLjc2LS4zSDk4LjU4djEyYTYuMzUsNi4zNSwwLDAsMCwxLjg2LDQuNDdoMEE2LjM0LDYuMzQsMCwwLDAsMTA0LjkxLDI3aDcuNTNaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTAwLjM0LDEyNy4zQTIxLjY0LDIxLjY0LDAsMSwxLDEyMiwxMDUuNjYsMjEuNjYsMjEuNjYsMCwwLDEsMTAwLjM0LDEyNy4zWm0wLTM3LjdhMTYuMDcsMTYuMDcsMCwxLDAsMTYuMDcsMTYuMDZBMTYuMDgsMTYuMDgsMCwwLDAsMTAwLjM0LDg5LjZaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTQwLjE2LDE0NS44YTIuNzcsMi43NywwLDAsMS0yLS44MkwxMTMsMTE5LjgxYTIuNzgsMi43OCwwLDAsMSwzLjkzLTMuOTRsMjUuMTgsMjUuMThhMi43OSwyLjc5LDAsMCwxLTIsNC43NVoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0xNDAuMTYsMTQ3Ljc2YTQuNyw0LjcsMCwwLDEtMy4zNS0xLjM5bC0xNi40Ni0xNi40NmE0Ljc0LDQuNzQsMCwwLDEsNi43MS02LjdsMTYuNDUsMTYuNDVhNC43NSw0Ljc1LDAsMCwxLTMuMzUsOC4xWiIvPjwvZz48L2c+PC9zdmc+);
}
.screen--1 .fancylink, h2.swBtn{
  cursor:pointer;
}

.answers-inner{
  @media screen and (max-width:959px){
    position:relative;
    margin:32px 0 120px;
    padding:29px;
    border:2px solid #eee6e0

  }
  @media screen and (min-width:960px){
    position:relative;
    margin:32px 0 120px;
    &:after{
      content: "";
      position: absolute;
      top: -32px;
      left: -32px;
      bottom: -32px;
      right: -32px;
      border:2px solid #eee6e0
    }
  }
}
@media screen and (min-width:960px){
.flex-box{
  display:flex;
  align-items: center;

  h3{
    margin:0;
  }
}
}
.r-icon{
    margin-right:20px;
    img{
      max-height:100px;
    }
  }
</style>
